import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, OptionCard, OptionCardContent, ProgressBar } from '../../components/ui';

const FOCUS_OPTIONS = [
  {
    value: 'skin',
    title: 'Skin glow-up',
  },
  {
    value: 'depuff',
    title: 'Depuff face',
  },
  {
    value: 'jawline',
    title: 'Jawline definition',
  },
  {
    value: 'hairstyle',
    title: 'Hairstyle',
  },
  {
    value: 'beard',
    title: 'Beard / grooming',
  },
  {
    value: 'harmony',
    title: 'Overall facial harmony',
  },
];

export function FocusAreasScreen() {
  const navigate = useNavigate();
  const { onboarding, updateOnboarding, nextStep } = useStore();

  const handleToggle = (value: string) => {
    const current = onboarding.focusAreas;
    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    updateOnboarding({ focusAreas: updated });
  };

  const handleContinue = () => {
    if (onboarding.focusAreas.length > 0) {
      nextStep();
      navigate('/onboarding/self-rating');
    }
  };

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={4} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-2">What do you want to improve?</h1>
        <div className="mb-6" />

        <div className="space-y-3 mb-8">
          {FOCUS_OPTIONS.map(({ value, title }) => (
            <OptionCard
              key={value}
              selected={onboarding.focusAreas.includes(value)}
              onClick={() => handleToggle(value)}
            >
              <OptionCardContent title={title} />
            </OptionCard>
          ))}
        </div>
      </div>

      <Button
        onClick={handleContinue}
        disabled={onboarding.focusAreas.length === 0}
      >
        Continue
      </Button>
    </div>
  );
}
